import React, { Component } from "react";
import { Col, Form, Modal, Button } from "react-bootstrap";

import { FieldGroup } from "./bootstrap/Forms.FieldGroup";
import { formDataToJSON } from "../adukku_utils/array";
import { authorized, Authorized } from "../adukku_utils/authorizeUser";

export default class AddUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
      email: props.edit_user && props.edit_user.email,
      login: props.edit_user && props.edit_user.login,
      view_user_user_type: props.view_user_user_type,
      view_user_product_code: props.view_user_product_code,
      view_user_password: props.view_user_password,
      view_and_pay_user_user_type: props.view_and_pay_user_user_type,
      view_and_pay_user_product_code: props.view_and_pay_user_product_code,
      view_and_pay_user_password: props.view_and_pay_user_password,
      user_id: props.user_id,
      product_id: props.product_id,
      
      is_update_code: "Click here to Generate New Product Code",
      
    };
      this._handleGenerateViewUserProductCode = this._handleGenerateViewUserProductCode.bind(this);
      this._handleGenerateViewAndPayUserProductCode = this._handleGenerateViewAndPayUserProductCode.bind(this);
      this._handleValidSubmit = this._handleValidSubmit.bind(this);
      this._handleAddViewUserValidSubmit = this._handleAddViewUserValidSubmit.bind(this);
      this.hideCreateLayoutOverlay = this.hideCreateLayoutOverlay.bind(this);
  }

  _handleGenerateViewUserProductCode = (e) => {
    let newCode = Math.round(Math.random() * (1000000));
    this.setState({ view_user_product_code: newCode });
  };

  _handleGenerateViewAndPayUserProductCode = (e) => {
    let newCode = Math.round(Math.random() * (1000000));
    this.setState({ view_and_pay_user_product_code: newCode });
  };

  _handleValidSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let formData = formDataToJSON(new FormData(e.target));
    if (formData["role"] === "editor") formData["name"] = formData.login;
    this.props.productUser(formData);
    this.setState({ show: false, view_pay_modal: false });
  };

  hideCreateLayoutOverlay= (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ show: false, view_pay_modal: false });
  }

  _handleAddViewUserValidSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let formData = formDataToJSON(new FormData(e.target));
    formData["user_id"] = this.props.user_id;
    this.props.addViewProductUser(formData);
    
    alert ("Make sure to share the PRODUCT_CODE & PASSWORD to your intended audience\n\nYour intended audience can then add your PRODUCT using VIEW/PAY PRODUCTS under DASHBOARD");
    this.setState({ show: false, view_pay_modal: false });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.edit_user !== nextProps.edit_user) {
      this.setState({
        ...nextProps,
        email: nextProps.edit_user && nextProps.edit_user.email,
        login: nextProps.edit_user && nextProps.edit_user.login,
      });
    }
  }

  render() {
    const { edit_user, email, login, role, labelText, isAddViewUser, isAddViewPayUser } = this.state;
    const style = {
      display: "none",
    };
    return (
      <React.Fragment>
{/* Commenting out Data Correction User for Phase 1        
        {role && !isAddViewUser && (
          <Authorized userRoles={[role, role]} requiredRoles={["admin", "owner"]} roleType="ANY">
            <li>
              <a variant="primary" onClick={() => this.setState({ show: true })}>
                
                {edit_user ? "Edit Data Correction User" : "Add Data Correction User"}
                
              </a>
              <Modal show={this.state.show} size="lg" centered="true">
                <Form className="override_form" onSubmit={this._handleValidSubmit}>
                  <Modal.Header closeButton>
                    <Modal.Title>Data Correction user</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Col md={12}>
                      <FieldGroup
                        id="formControlProduct"
                        type="text"
                        label="Product ID"
                        name="product_id"
                        placeholder="Product ID"
                        required="required"
                        style={style}
                        value={this.state.product_id}
                        readOnly={true}
                      />
                      <FieldGroup
                        id="formControlRole"
                        type="text"
                        name="role"
                        required="required"
                        style={style}
                        value={"editor"}
                        readOnly={true}
                      />
                      <FieldGroup
                        id="formControlEmail"
                        type="text"
                        label="Email"
                        name="email"
                        placeholder="Email address"
                        required="required"
                        disabled={edit_user ? true : false}
                        value={email ? email : ""}
                        onChange={({ target: { name, value } }) => {
                          this.setState({ [name]: value });
                        }}
                      />
                      <FieldGroup
                        id="formControlUsername"
                        type="text"
                        label="Username"
                        name="login"
                        placeholder="Username"
                        required="required"
                        disabled={edit_user ? true : false}
                        value={login ? login : ""}
                        onChange={({ target: { name, value } }) => {
                          this.setState({ [name]: value });
                        }}
                      />
                      <FieldGroup
                        id="formControlPassword"
                        type="password"
                        label="password"
                        name="password"
                        placeholder="Password"
                        required={this.props.is_password_set ? null : "required"}
                      />
                    </Col>
                    <hr></hr>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button type="submit">Submit</Button>
                    <Button onClick={() => this.setState({ show: false })}>Close</Button>
                  </Modal.Footer>
                </Form>
              </Modal>
            </li>
          </Authorized>
        )}
*/}
        {isAddViewUser && (
          <li>
            <a variant="primary" onClick={() => this.setState({ view_pay_modal: true })}>
              {this.props.view_user_password ? `Edit ${labelText}` : `Add ${labelText}`}
            </a>
            <Modal show={this.state.view_pay_modal} onHide={this.hideCreateLayoutOverlay} size="lg" centered="true">
            <Modal.Header closeButton>
                <Modal.Title>{this.props.view_user_password ? `Edit ${labelText}` : `Add ${labelText}`}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form horizontal onSubmit={this._handleAddViewUserValidSubmit}>
                  <Col md={12}>
                    <FieldGroup
                      id="formControlProduct"
                      type="text"
                      label="Product ID"
                      name="product_id"
                      placeholder="Product ID"
                      required="required"
                      style={style}
                      value={this.props.product_id}
                      readOnly={true}
                    />
                    <FieldGroup
                      id="formControlUser"
                      type="text"
                      label="User ID"
                      name="user_id"
                      placeholder="User ID"
                      required="required"
                      style={style}
                      // value={this.props.user_id}
                      readOnly={true}
                    />
                    <FieldGroup
                      id="formControlProductCode"
                      type="text"
                      label="product code"
                      name="product_code"
                      placeholder="product_code"
                      required="required"
                      // defaultValue={this.state.view_user_product_code ? this.state.view_user_product_code : "Generate New Code" }
                      value={this.state.view_user_product_code ? this.state.view_user_product_code : "Generate New Code" }
                      // value={this.state.view_user_product_code}
                      readOnly={true}
                    />
                    {/* Bala*/}

                    <div className="input-group">
                      <input type="button" className="btn btn-primary"
                        id="ProductCodeButton"
                        name="is_update_code"
                        required="required"
                        value="Generate Product Code"
                        onClick={(e) => {
                          let yesNo = confirm("Are you sure?\nOld Product Code (if any) will not work anymore!!!")  
                          if (yesNo) {
                          this._handleGenerateViewUserProductCode()
                          alert("New Product Code Generated")  
                        }
                        }}
                      ></input>
                </div>
 
                    <FieldGroup
                      id="formControlUserType"
                      type="text"
                      name="user_type"
                      required="required"
                      style={style}
                      value="viewer"
                      readOnly={true}
                    />
                    <FieldGroup
                      id="Password"
                      type="text"
                      label="password"
                      name="password"
                      defaultValue={this.state.view_user_password ? this.state.view_user_password : ""}
                      onChange={(e) => {
                        this.setState({
                          view_user_password: e.target.value,
                        });
                      }}
                      placeholder="Enter a Password"
                      required="required"
                    />
                  </Col>
                  <hr></hr>
                  <Button type="submit">Submit</Button>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={() => this.setState({ view_pay_modal: false })}>Close</Button>
              </Modal.Footer>
            </Modal>
          </li>
        )}{" "}
        {isAddViewPayUser && (
          <li>
            <a variant="primary" onClick={() => this.setState({ view_pay_modal: true })}>
              {this.props.view_and_pay_user_password ? `Edit ${labelText}` : `Add ${labelText}`}
            </a>
            <Modal show={this.state.view_pay_modal} onHide={this.hideCreateLayoutOverlay} size="lg" centered="true">
            <Modal.Header closeButton>
            <Modal.Title>{this.props.view_and_pay_user_password ? `Edit ${labelText}` : `Add ${labelText}`}</Modal.Title>
             </Modal.Header>
              <Modal.Body>
                <Form horizontal onSubmit={this._handleAddViewUserValidSubmit}>
                  <Col md={12}>
                    <FieldGroup
                      id="formControlProduct"
                      type="text"
                      label="Product ID"
                      name="product_id"
                      placeholder="Product ID"
                      required="required"
                      style={style}
                      value={this.props.product_id}
                      readOnly={true}
                    />
                    <FieldGroup
                      id="formControlUser"
                      type="text"
                      label="User ID"
                      name="user_id"
                      placeholder="User ID"
                      required="required"
                      style={style}
                      // value={this.props.user_id}
                      readOnly={true}
                    />
                    <FieldGroup
                      id="formControlProductCode"
                      type="text"
                      label="product code"
                      name="product_code"
                      placeholder="product_code"
                      required="required"
                      // defaultValue={this.state.view_and_pay_user_product_code ? this.state.view_and_pay_user_product_code : "Generate New Code" }
                      value={this.state.view_and_pay_user_product_code ? this.state.view_and_pay_user_product_code : "Generate New Code" }
                      // value={this.state.view_and_pay_user_product_code}
                      readOnly={true}
                    />
                    {/* Bala*/}

                    <div className="input-group">
                      <input type="button" className="btn btn-primary"
                        id="ProductCodeButton"
                        name="is_update_code"
                        required="required"
                        value="Generate Product Code"
                        onClick={(e) => {
                          let yesNo = confirm("Are you sure?\nOld Product Code (if any) will not work anymore!!!")  
                          if (yesNo) {
                          this._handleGenerateViewAndPayUserProductCode()
                          alert("New Product Code Generated")  
                        }
                        }}
                      ></input>
                </div>
 
                    <FieldGroup
                      id="formControlUserType"
                      type="text"
                      name="user_type"
                      required="required"
                      style={style}
                      value="view_and_pay"
                      readOnly={true}
                    />
                    <FieldGroup
                      id="Password"
                      type="text"
                      label="password"
                      name="password"
                      defaultValue={this.state.view_and_pay_user_password ? this.state.view_and_pay_user_password : ""}
                      onChange={(e) => {
                        this.setState({
                          view_and_pay_user_password: e.target.value,
                        });
                      }}
                      placeholder="Enter a Password"
                      required="required"
                    />
                  </Col>
                  <hr></hr>
                  <Button type="submit">Submit</Button>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={() => this.setState({ view_pay_modal: false })}>Close</Button>
              </Modal.Footer>
            </Modal>
          </li>
        )}{" "}
      </React.Fragment>
    );
  }
}
